import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import { SPACES } from 'common/constants/sizes';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { formatStartEndDate } from 'common/utils/time.utils';
import { getColor } from 'common/constants/_colors';
import { PROJECTS } from '../services/projects.services';
import { PROVIDERS_MAP } from 'common/constants/constants';

const Label = styled.div`
  color: ${getColor('shark')};
  border: 1px solid ${getColor('botticelli')};
  border-radius: 4px;
  padding: 0.4rem 0.7rem 0.3rem 0.7rem;
  margin: 0 0.45rem 0.45rem 0;
  font-size: 1rem;
  span {
    text-transform: uppercase;
    font-weight: 500;
  }
`;

const ProjectLabelsAndCadence = ({
  project = {},
  lastIteration,
  isExtendedView = false
}) => {
  const {
    cadence = {},
    parent_issues: issues,
    boards,
    labels,
    epics,
    provider
  } = project;
  const { type, days = 1 } = cadence;
  const { icon, title, description } = type ? PROJECTS.TYPES[type] : {};
  const isAzureBoardsProject =
    provider === PROVIDERS_MAP.azure_boards.provider_path;

  const getNormalizedName = item => {
    if (typeof item === 'string') return item;
    return item?.title || item?.name;
  };

  // Group issues by type and extract titles
  const groupedIssuesByType = issues?.reduce((acc, issue) => {
    if (!issue.type) return acc;
    acc[issue.type] = acc[issue.type] || [];
    acc[issue.type].push(issue.title);
    return acc;
  }, {});

  const normalizedArrays = {
    [isAzureBoardsProject ? 'teams' : 'boards']:
      boards?.map(getNormalizedName) || [],
    labels: labels?.map(getNormalizedName) || [],
    epics: epics?.map(getNormalizedName) || [],
    ...groupedIssuesByType
  };

  /* istanbul ignore next */
  const getLastIterationData = ({ name = '', start, end }) => {
    return `iteration: ${name} - ${formatStartEndDate(start, end)}`;
  };

  const iterationData =
    lastIteration && !isExtendedView
      ? getLastIterationData(lastIteration)
      : `${description || `${_.round(days / 7, 1)} week`} iterations`;

  const wrapperStyle = isExtendedView
    ? { pt: 'small', pb: 'small', maxWidth: '24rem' }
    : {};

  return (
    <Flex direction='column' {...wrapperStyle}>
      <Flex wrap='wrap'>
        {Object.entries(normalizedArrays).map(([key, value]) =>
          value.length ? (
            <Label key={key} data-testid='project-label'>
              <span>{`${key}: `}</span>
              {value.join(', ')}
            </Label>
          ) : null
        )}
      </Flex>
      <Flex items='center' pt='x-x-small'>
        <Icon
          name={icon}
          size='smaller'
          color='silverSand'
          data-testid='project-type-icon'
        />
        <Text
          size='small'
          color={PROJECTS.SECONDARY_COLOR}
          pl={SPACES['x-small']}
          data-testid='project-type'
        >
          {title}
        </Text>
        <Text
          size='large'
          color='botticelli'
          pl={SPACES['x-small']}
          pr={SPACES['x-small']}
        >
          |
        </Text>
        <Text
          size='small'
          color={PROJECTS.SECONDARY_COLOR}
          data-testid='project-type-duration'
        >
          {iterationData}
        </Text>
      </Flex>
    </Flex>
  );
};

export default ProjectLabelsAndCadence;
